'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');
const Usage = require('./usage');

class Subscriptions {
  constructor(credentials, request, sdkConfiguration, customerId) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager([customerId]);
    this.request = request;
    this.sdkConfiguration = sdkConfiguration;
    this.credentials = credentials;
    this.customerId = customerId;
  }

  byId(subscriptionId) {
    this.paramsManager.addPathParam(subscriptionId);
    this.subscriptionId = subscriptionId;
    this.usage = new Usage(this.credentials, this.request, this.sdkConfiguration, this.customerId, this.subscriptionId);
    return this;
  }

  get() {
    if (this.subscriptionId) {
      this.requestManager.requestConfigurationManager.setApi('GetSubscription');
    } else {
      this.requestManager.requestConfigurationManager.setApi('GetAllSubscriptions');
    }
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  getAddons() {
    this.validateSubscriptionId();
    this.requestManager.requestConfigurationManager.setApi('GetSubscriptionAddOns');
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  updateQuantity(quantity) {
    return this.patch({
      Id: this.subscriptionId,
      Quantity: quantity,
    });
  }

  suspend() {
    return this.patch({
      Id: this.subscriptionId,
      Status: 'suspended',
    });
  }

  activate() {
    return this.patch({
      Id: this.subscriptionId,
      Status: 'active',
    });
  }

  updatePartner(mpn) {
    return this.patch({
      Id: this.subscriptionId,
      PartnerId: mpn,
    });
  }

  patch(subscription) {
    this.validateSubscriptionId();
    this.requestManager.requestConfigurationManager.setApi('PatchSubscription');
    this.paramsManager.addBodyParams(subscription);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  validateSubscriptionId() {
    if (!this.subscriptionId) {
      throw errorHandler.handleError('To use this function, first use the byId function, to set the subscriptionId');
    }
  }
}

module.exports = Subscriptions;
